import React from 'react';
import styles from './style.module.css';

interface Props {
  image: string;
  title: string;
  lead?: string;
}

/** Шапка внутренних страниц: фото, затемнение, H1. */
const PageHero: React.FC<Props> = ({ image, title, lead }) => (
  <header className={styles.hero}>
    <img src={image} alt="" className={styles.image} fetchPriority="high" />
    <div className={styles.overlay}>
      <h1 className={styles.title}>{title}</h1>
      {lead && <p className={styles.lead}>{lead}</p>}
    </div>
  </header>
);

export default PageHero;
